import * as mns from '../mutation-types';

export default {
    state () {
        return {
            personalFormType: '',       // Какая сейчас форма: "Расторгнуть договор страхования", "Продлить договор страхования"...
            personalLastName: '',       // Фамилия.
            personalName: '',           // Имя.
            personalPatronymic: '',     // Отчество.
            personalEmail: '',          // Электронная почта.
            personalBank: '',           // Банк.
            personalContractNumber: '', // Номер договора.
            personalAppeal: '',         // Текст обращения.
            personalAgree: false,       // Ознакомлен?.
        }
    },
    getters: {
        personalFormType(state){
            return state.personalFormType;
        },
        personalLastName(state){
            return state.personalLastName;
        },
        personalName(state){
            return state.personalName;
        },
        personalPatronymic(state){
            return state.personalPatronymic;
        },
        personalEmail(state){
            return state.personalEmail;
        },
        personalBank(state){
            return state.personalBank;
        },
        personalContractNumber(state){
            return state.personalContractNumber;
        },
        personalAppeal(state){
            return state.personalAppeal;
        },
        personalAgree(state){
            return state.personalAgree;
        },
    },
    mutations: {
        [mns.SET_PERSONAL_FORM_TYPE](state, value){
            state.personalFormType = value;
        },
        [mns.SET_PERSONAL_LAST_NAME](state, value){
            state.personalLastName = value;
        },
        [mns.SET_PERSONAL_NAME](state, value){
            state.personalName = value;
        },
        [mns.SET_PERSONAL_PATRONYMIC](state, value){
            state.personalPatronymic = value;
        },
        [mns.SET_PERSONAL_EMAIL](state, value){
            state.personalEmail = value;
        },
        [mns.SET_PERSONAL_BANK](state, value){
            state.personalBank = value;
        },
        [mns.SET_PERSONAL_CONTRACT_NUMBER](state, value){
            state.personalContractNumber = value;
        },
        [mns.SET_PERSONAL_APPEAL](state, value){
            state.personalAppeal = value;
        },
        [mns.SET_PERSONAL_AGREE](state, value){
            state.personalAgree = value;
        },
    }
} // export.